/**
 * Created by slava on 10/8/18
 */

class HeroesSceneComponent extends ScriptComponent {
    onAttach() {
        this.sceneComponent = ComponentMap.get(this.node, SceneComponent);

        const styling = cleverapps.clone(cleverapps.styles.HeroesScene.background);
        if (cleverapps.resolution.mode === cleverapps.WideMode.HORIZONTAL) {
            styling.backgroundId = "heroes_bg_horizontal";
            styling.animation = bundles.heroes_scene.jsons.heroes_bg_horizontal_json;
        } else {
            styling.backgroundId = "heroes_bg_vertical";
            styling.animation = bundles.heroes_scene.jsons.heroes_bg_vertical_json;
        }

        this.sceneComponent.setStyling(styling);
        this.sceneComponent.setBundles(["heroes_scene"]);
    }

    onSceneLoaded() {
        match3.heroes.onHeroChangeLevel = this.node.createListener(this.heroBuildingUpgraded.bind(this));

        this.heroBuildings = {};
        this.house = this.createHouse();
        this.node.addChild(this.house);
        cleverapps.styles.HeroesScene.heroBuildings.forEach(function (building) {
            const type = building.color;
            this.heroBuildings[type] = this.createHeroBuilding(building, match3.heroes.getLevel(type));
            this.house.addChild(this.heroBuildings[type]);
        }, this);

        cleverapps.exp.on("changeExp", this.node.createListener(this.updateAllInfo.bind(this)), this.node);

        this.customize();
        this.onResize();

        cleverapps.placements.run(Placements.INTERMEDIATE);
    }

    onPressed(building) {
        cleverapps.focusManager.display({
            stack: cleverapps.forces.isRunningForce(),
            focus: "HeroWindow",
            control: ["MenuBarGoldItem", "MenuBarExpItem"],
            action: function (f) {
                new HeroWindow({ color: building.hero_color });
                cleverapps.focusManager.onceNoWindowsListener = f;
            }
        });
    }

    createHouse() {
        if (!cleverapps.styles.HeroesScene.house.separateFromBg) {
            return new cc.Node();
        }
        const house = new cc.Node();
        const houseBg = new cc.Sprite(bundles.heroes_scene.urls.house);
        houseBg.setScale(this.node.height / houseBg.height);
        house.addChild(houseBg);
        return house;
    }

    onResize() {
        if (this.node.background) {
            this.node.background.setScale(Math.max(cleverapps.resolution.getBgSize().height / this.node.background.height, cleverapps.resolution.getBgSize().width / this.node.background.width));
        }

        if (this.house) {
            this.house.setAlignment(cleverapps.styles.HeroesScene.house.position);
        }
    }

    createHeroBuilding(buildingStyles, level) {
        const building = new cc.Node();
        building.hero_color = buildingStyles.color;

        const styles = cleverapps.styles.HeroesScene;

        cleverapps.UI.onClick(building, this.onPressed.bind(this, building));

        const color = buildingStyles.color.toUpperCase();

        const animationNode = new cc.Node();
        animationNode.setAnchorPoint(0.5, 0.5);
        animationNode.setContentSize2(styles.heroBuilding.width, styles.heroBuilding.height);

        const animation = building.animation = new cleverapps.Spine(cleverapps.skins.getSlot(`${color}_hero_spine_json`) || bundles.heroes.jsons[`${color}_hero_spine_json`]);
        animation.setScale(styles.heroBuilding.scale || 1.0);
        animation.setSkin(match3.heroes.getCurrentSkin());
        animation.setAnimation(0, "idle", true);
        animationNode.addChild(animation);
        animation.setAlignment(animationNode.width / 2, animationNode.height / 2);

        const button = building.button = this.createButton(building);

        const content = new cleverapps.Layout([animationNode, button], {
            direction: cleverapps.UI.VERTICAL,
            margin: styles.margin
        });

        building.setContentSize2(content.getContentSize());
        building.addChild(content);
        content.setAlignment(building.width / 2, building.height / 2);

        const levelBlock = building.levelBlock = cleverapps.UI.createScale9Sprite(styles.levelBlock.bg);
        levelBlock.setContentSize2(styles.levelBlock.width, styles.levelBlock.height);
        levelBlock.setAlignment(building.width / 2 + styles.levelBlock.x, building.height / 2 + styles.levelBlock.y);
        building.addChild(levelBlock);

        if (level === 0) {
            levelBlock.setVisible(false);
        }

        if (!match3.heroes.isHeroAvailable(building.hero_color)) {
            if (cleverapps.config.name === "adventure") {
                animation.setColor(new cc.Color(120, 120, 120, 255));
            } else {
                cleverapps.UI.convertToGrayScale(animation.spine);
            }
        }

        this.updateLevelText(levelBlock, level);
        building.setAnchorPoint(0.5, 0.5);
        building.setAlignment(buildingStyles);

        return building;
    }

    createButton(building) {
        const color = building.hero_color;
        const canUpgrade = match3.heroes.canUpgradeHero(color);
        const level = match3.heroes.getLevel(color);
        const isMaxLvl = match3.heroes.isMaxLevel(color);

        const styles = cleverapps.styles.HeroesScene.buttons;

        let text, disabled;
        if (!match3.heroes.isHeroAvailable(color)) {
            const level = cleverapps.config.availables[`OPEN_HERO_${color}`] || cleverapps.config.availables.HEROES;

            text = Messages.get("Available.level", {
                level
            });
            disabled = true;
        } else if (match3.heroes.isMaxLevel(color)) {
            text = Messages.get("Heroes.Info.MaxLevel");
        } else if (canUpgrade) {
            text = Messages.get(level === 0 ? "Heroes.Unlock.Button" : "Heroes.Upgrade.Button");
        } else {
            text = `%%${cleverapps.exp.getExp()}/${match3.heroes.expUpgradePrice(color)}`;
        }

        const button = new cleverapps.UI.Button({
            disabled,
            text,
            icons: {
                "%%": bundles.reward_icons.frames.reward_exp_png
            },
            type: canUpgrade || isMaxLvl ? cleverapps.styles.UI.Button.Images.small_button_green : cleverapps.styles.UI.Button.Images.small_button_blue,
            width: styles.width,
            height: styles.height,
            onClicked: this.onPressed.bind(this, building)
        });

        if (canUpgrade) {
            const attention = new Attention();
            attention.setAlignment(styles);

            button.addChild(attention);
        }

        return button;
    }

    updateLevelText(parent, level) {
        parent.removeAllChildren();
        const styles = cleverapps.styles.HeroesScene;
        // eslint-disable-next-line no-restricted-syntax
        const levelText = cleverapps.UI.generateTTFText(level, styles.levelBlock.font);
        levelText.setAlignment(parent.width / 2, parent.height / 2);
        parent.addChild(levelText);
    }

    updateAllInfo() {
        for (const color in this.heroBuildings) {
            this.updateBuildingInfo(this.heroBuildings[color]);
        }
    }

    updateBuildingInfo(building) {
        const buttonPos = building.button.getPosition();
        building.button.removeFromParent();
        building.button = this.createButton(building);
        building.addChild(building.button);
        building.button.setAlignment(buttonPos);
    }

    heroBuildingUpgraded(color) {
        const styles = cleverapps.styles.HeroesScene;
        const building = this.heroBuildings[color];
        building.levelBlock.setVisible(false);
        building.button.setVisible(false);
        if (cleverapps.config.name === "adventure") {
            building.animation.setColor(new cc.Color(255, 255, 255, 255));
        } else {
            cleverapps.UI.convertToGrayScale(building.animation.spine, true);
        }
        this.updateBuildingInfo(building);
        building.runAction(new cc.Sequence(
            new cc.DelayTime(0.5),
            new cc.CallFunc(() => {
                building.levelBlock.setVisible(true);
                building.levelBlock.setScale(0);
                building.button.setScale(0);
                this.updateLevelText(building.levelBlock, match3.heroes.getLevel(color));
                building.levelBlock.runAction(new cc.ScaleTo(0.3, 1));
                building.button.runAction(new cc.ScaleTo(0.3, 1));
            }),
            new cc.DelayTime(0.5)
        ));

        const upgradeAnimation = new cleverapps.Spine(bundles.heroes_scene.jsons.hero_upgrade_json);
        upgradeAnimation.setAnimation(0, "animation", false);
        upgradeAnimation.setLocalZOrder(1);
        upgradeAnimation.setAlignment(styles.upgradeAnimation);
        building.addChild(upgradeAnimation);

        cleverapps.effects.fire("match3.heroes.stage.change");

        upgradeAnimation.setCompleteListener(() => {
            upgradeAnimation.runAction(new cc.RemoveSelf());
        });
    }

    customize() {
    }
}

Prefab.registerComponent("HeroesSceneComponent", HeroesSceneComponent);

cleverapps.styles.HeroesScene = {
    background: {
        bundle: "heroes_scene",
        backgroundId: "heroes_bg_vertical",
        scale: 2.0
    },

    margin: 40,

    upgradeAnimation: {
        x: { align: "center" },
        y: { align: "center" }
    },

    buttons: {
        x: { align: "right", dx: 20 },
        y: { align: "top", dy: 20 },

        width: 220,
        height: 70
    },

    levelBlock: {
        bg: bundles.heroes.frames.heroes_level_bg || bundles.main.frames.heroes_level_bg,
        font: cleverapps.styles.FONTS.WINDOW_WHITE_TEXT,
        width: 70,
        height: 50,
        x: -70,
        y: 135
    },

    house: {
        separateFromBg: false,
        position: {
            x: { align: "center", dx: 0 },
            y: { align: "center", dy: 0 }
        }
    },

    heroBuilding: {
        width: 120,
        height: 120,
        scale: 1.5
    },

    heroBuildings: [
        {
            color: "e",
            x: { align: "center", dx: -180 },
            y: { align: "center", dy: 320 }
        },
        {
            color: "d",
            x: { align: "center", dx: 180 },
            y: { align: "center", dy: 320 }
        },
        {
            color: "a",
            x: { align: "center", dx: -180 },
            y: { align: "center", dy: 0 }
        },
        {
            color: "b",
            x: { align: "center", dx: 180 },
            y: { align: "center", dy: 0 }
        },
        {
            color: "c",
            x: { align: "center", dx: -180 },
            y: { align: "center", dy: -320 }
        },
        {
            color: "w",
            x: { align: "center", dx: 180 },
            y: { align: "center", dy: -320 }
        }
    ]
};
